import { axiosMicroservice } from 'src/api/axios';
import type { TpStripeCreateSubscription } from 'src/features/Stripe/types';

export const createSubscription = async ({
  priceId,
  userId,
  currency,
  email,
  token,
  introOfferId,
  introOfferDuration,
  cancelAtPeriodEnd,
  app,
}: TpStripeCreateSubscription): Promise<{
  client_secret: string;
  customer_id: string;
  subscription_id: string;
}> => {
  const { data } = await axiosMicroservice.post('stripe/create_subscription', {
    price_id: priceId,
    user_id: userId,
    currency: currency,
    intro_offer_id: introOfferId,
    intro_offer_duration: introOfferDuration,
    email: email,
    token: token,
    cancel_at_period_end: cancelAtPeriodEnd,
    app: app,
  });
  return data;
};
